import React, { useState, useEffect, useRef,useContext } from 'react';
import { usePromoCodeInput,EventContext } from '../CartContext'; // Import the custom hook
import { Button } from 'react-bootstrap';

const Modal = ({ isOpen, closeModal }) => {
    const promoRef = useRef();
    const [localPromoCode, setLocalPromoCode] = useState(''); // Local state for the input field
    const { settings } = useContext(EventContext);

    const [settingsLoaded, setSettingsLoaded] = useState(false);

    useEffect(() => {
      if (settings) {
        setSettingsLoaded(true); // Mark settings as loaded
      }
    }, [settings]); 

    const { promoCodeStatus, updatePromoCode, promoCodeInput,promoCodeClosed, setPromoCodeClosed } = usePromoCodeInput();

    // Handle save when user clicks Enter
    function handleSave() {
        updatePromoCode(localPromoCode); // Update global state with the local value
        //closeModal();
    }

    
    if ((!settingsLoaded || !isOpen) || settings?.ES_PROMO_POPUP === 0 || settings?.ES_PROMO_POPUP === 1 || promoCodeClosed === 1) return null; // Render nothing if the modal is closed or promocode is already set.

    return (
      <div style={modalOverlayStyle}>
        <div style={modalContentStyle}>
          <h5>Please enter your promo code</h5>
          <input
            type="text"
            placeholder="Type here..."
            value={localPromoCode} // Bind to local state
            onChange={(e) => setLocalPromoCode(e.target.value)} // Update local state on input change
            ref={promoRef}
          />
          <Button className='btn btn-info btn-atc' onClick={handleSave}>Enter</Button><br></br><br></br>
          <p>{promoCodeStatus}</p>

          <Button className='btn btn-info btn-atc' onClick={() => { closeModal(); setPromoCodeClosed(1); }}>Close</Button>

        </div>
      </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const modalContentStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
};

export default Modal;
